import { motion } from 'motion/react';
import { whyChooseUs } from '@/mocks/homeData';

export default function WhyChooseUs() {
  return (
    <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary-500/[0.02] rounded-full blur-[100px] pointer-events-none"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14 md:mb-20"
        >
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-600 mb-4">
            Why BEKAALI
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-4">
            The BEKAALI Advantage
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Six pillars that set us apart and ensure your trade and procurement operations deliver maximum value.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {whyChooseUs.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group p-6 md:p-8 bg-background-100 border border-background-200/70 rounded-2xl hover:border-accent-200/50 hover:bg-background-50 transition-all duration-400"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-white transition-all duration-400">
                <i className={`${item.icon} text-xl`}></i>
              </div>

              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors duration-200">
                {item.title}
              </h3>

              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}